/* GB ARENA — tudo carregado antes de entrar, para nada travar durante a partida.
   Os arquivos vão para o cache do navegador, então quando a batalha abre no iframe
   o Phaser pega tudo da memória em vez de baixar no meio do jogo. */

export const GB_ASSETS = [
  '/gb/halo_logo.webp',
  '/gb/capa_retrato.jpg',
  '/gb/capa_paisagem.jpg',
  '/gb/arena_pvp.jpg',
  '/gb/caveira.png',
  '/gb/aviao.png',
  '/gb/caixa.png',
  '/gb/icon_aviao.png',
  '/gb/icon_caveira.png',
  '/gb/card_defeat.png',
  '/gb/card_defeat2.png',
  '/gb/card_victory.png',
  '/gb/card_victory2.png',
  '/gb/duel_bg.jpg',
  '/gb/icon_armor.png',
  '/gb/icon_dmg.png',
  '/gb/icon_fuel.png',
  '/gb/icon_missil.png',
  '/gb/icon_pocao.png',
  '/gb/icon_tornado.png',
  '/gb/map_castle.jpg',
  '/gb/map_graveyard.jpg',
  '/gb/map_pumpkin.jpg',
  '/gb/medals/carneiro.webp',
  '/gb/medals/cervo.webp',
  '/gb/medals/cobra.webp',
  '/gb/medals/coruja.webp',
  '/gb/medals/corvo.webp',
  '/gb/medals/dragao.webp',
  '/gb/medals/escorpiao.webp',
  '/gb/medals/fenix.webp',
  '/gb/medals/grifo.webp',
  '/gb/medals/javali.webp',
  '/gb/medals/kraken.webp',
  '/gb/medals/leao.webp',
  '/gb/medals/lobo.webp',
  '/gb/medals/pantera.webp',
  '/gb/medals/pavao.webp',
  '/gb/medals/pegaso.webp',
  '/gb/medals/raposa.webp',
  '/gb/medals/tigre.webp',
  '/gb/medals/tubarao.webp',
  '/gb/medals/urso.webp',
  '/gb/missile.png',
  '/gb/mobile.png',
  '/gb/opponents/abobora.jpg',
  '/gb/opponents/bruxa.jpg',
  '/gb/opponents/esqueleto.jpg',
  '/gb/opponents/fantasma.jpg',
  '/gb/opponents/vampiro.jpg',
  '/gb/soil_castle.jpg',
  '/gb/soil_graveyard.jpg',
  '/gb/soil_pumpkin.jpg',
  '/gb/soil_r1.jpg',
  '/gb/soil_r2.jpg',
  '/gb/soil_r3.jpg',
  '/gb/soil_r4.jpg',
  '/gb/soil_r5.jpg',
  '/gb/soil_r6.jpg',
  '/gb/stage.jpg',
  '/gb/tanks/bruxa/sprite.png',
  '/gb/tanks/laranja.png',
  '/gb/tanks/amarelo.png',
  '/gb/tanks/verde.png',
  '/gb/tanks/roxo.png',
  '/gb/tanks/rosa.png',
  '/gb/tanks/marrom.png',
  '/gb/tanks/preto.png',
  '/gb/tanks/branco.png',
  '/gb/tanks/azul.png',
  '/gb/tanks/vermelho.png',
  '/gb/tornado.png',
  '/gb/world/bg.webp',
  '/gb/world/c1.webp',
  '/gb/world/c2c.webp',
  '/gb/world/c3.webp',
  '/gb/world/c4.webp',
  '/gb/world/c5.webp',
  '/gb/world/c6.webp',
  '/gb/world/m1.webp',
  '/gb/world/m2.webp',
  '/gb/world/m3.webp',
  '/gb/world/m4.webp',
  '/gb/world/m5.webp',
  '/gb/world/m6.webp',
  '/gb/world/s1.png',
  '/gb/world/s10.png',
  '/gb/world/s11.png',
  '/gb/world/s12.png',
  '/gb/world/s13.png',
  '/gb/world/s14.png',
  '/gb/world/s15.png',
  '/gb/world/s16.png',
  '/gb/world/s17.png',
  '/gb/world/s18.png',
  '/gb/world/s19.png',
  '/gb/world/s2.png',
  '/gb/world/s20.png',
  '/gb/world/s21.png',
  '/gb/world/s22.png',
  '/gb/world/s23.png',
  '/gb/world/s24.png',
  '/gb/world/s3.png',
  '/gb/world/s4.png',
  '/gb/world/s5.png',
  '/gb/world/s6.png',
  '/gb/world/s7.png',
  '/gb/world/s8.png',
  '/gb/world/s9.png',
  '/gb/world/tank.png',
  '/oil/podium_top3.webp',
  '/oil/kako_coin.png',
  '/gb/title_jackpot.webp',
  '/gb/ic_regras.webp',
];

const pegar = (url) => new Promise((resolve) => {
  const fim = setTimeout(resolve, 9000);          // arquivo pendurado não trava a barra
  if (/\.(png|jpe?g|webp|gif)$/i.test(url)) {
    const img = new Image();
    img.onload = img.onerror = () => { clearTimeout(fim); resolve(); };
    img.src = url;
  } else {
    fetch(url, { cache: 'force-cache' }).catch(() => {}).finally(() => { clearTimeout(fim); resolve(); });
  }
});

/* Baixa tudo com 6 downloads ao mesmo tempo e avisa o progresso (0 a 100). */
export const preloadGb = async (onProgress, lista = GB_ASSETS) => {
  const total = lista.length || 1;
  let prontos = 0;
  const fila = [...lista];
  const trabalhador = async () => {
    while (fila.length) {
      const url = fila.shift();
      await pegar(url);
      prontos += 1;
      onProgress?.(Math.min(100, Math.round((prontos / total) * 100)));
    }
  };
  await Promise.all(Array.from({ length: 6 }, trabalhador));
  onProgress?.(100);
};
